// extracted by mini-css-extract-plugin
module.exports = {"row":"about-module--row--3npfJ","image":"about-module--image--30W-N","contentColumn":"about-module--contentColumn--3H7lK"};